<template>
  <div v-if="accountInfo" class="account" v-resize="setContentHeight">
    <v-toolbar dark color="primary" class="px-1">
      <v-toolbar-title
        v-if="accountInfo.visitBookingMonthlyCountsForNonNlbUser"
        xclass="text-capitalize"
        >{{ accountInfo.name }}</v-toolbar-title
      >
      <v-toolbar-title v-else class="text-capitalize">{{
        accountInfo.name
      }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="confirmLogout">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card
      v-if="accountInfo.accountType !== 'User' && visitBookingEnabled"
      tile
      class="px-2 py-1 text-small font-weight-bold primary--text text-left"
      style="
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        width: 100%;
      "
    >
      Number of bookings left in this month:
      {{ accountInfo.visitBookingMonthlyCountsForNonNlbUser }}
    </v-card>
    <v-card
      v-else
      tile
      class="px-2 py-1 text-small font-weight-bold primary--text text-left"
      style="
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        width: 100%;
      "
      >Daily Booking Quota<span v-if="windowSettings.showCCKPLQuota">s</span>
    </v-card>

    <div
      v-if="accountInfo.accountType !== 'User' && visitBookingEnabled"
      class="px-2 py-1 pt-2 text-small font-weight-bold primary--text text-left"
      style="position: absolute"
    >
      Daily Booking Quota<span v-if="windowSettings.showCCKPLQuota">s</span>
    </div>

    <div
      ref="accountScrollable"
      class="scrollable text-center pt-2 pb-4"
      :class="contentHeight > 300 ? 'flex-center-container' : ''"
    >
      <div
        v-if="quotas && quotas.cckpl && windowSettings.showCCKPLQuota"
        style="height: 167px"
      >
        <v-progress-circular
          rotate="-90"
          size="167"
          width="15"
          :value="quotas.cckpl.percentage"
          :color="
            quotas.cckpl.remainingQuotaInMinutes > 0 ? 'primary' : 'orange'
          "
          style="height: inherit"
        >
          <div>
            <div style="color: black; font-weight: bold; font-size: 12px">
              Breakout Zones
            </div>

            <div class="mt-1 font-weight-bold" style="font-size: 22px">
              {{ quotas.cckpl.text }}
            </div>
          </div>
        </v-progress-circular>
      </div>

      <div
        v-if="quotas && quotas.studyArea"
        :style="
          windowSettings.showCCKPLQuota ? 'height: 272px' : 'height: 300px'
        "
        class="pt-2"
      >
        <v-progress-circular
          rotate="-90"
          :size="windowSettings.showCCKPLQuota ? 272 : 300"
          width="24"
          :value="quotas.studyArea.percentage"
          :color="
            quotas.studyArea.remainingQuotaInMinutes > 0 ? 'primary' : 'orange'
          "
          style="height: inherit"
        >
          <div>
            <div style="color: black; font-weight: bold; font-size: 16px">
              Study Areas
            </div>

            <div class="mt-1 font-weight-bold" style="font-size: 40px">
              {{ quotas.studyArea.text }}
            </div>
          </div>
        </v-progress-circular>
      </div>
    </div>
  </div>
</template>

<script>
import formatters from "@/helpers/formatters";
import { mapGetters } from "vuex";

export default {
  name: "Account",
  data: () => ({
    minWindowSize: 0,
    contentHeight: 0,
  }),
  computed: {
    ...mapGetters(["visitBookingEnabled"]),
    quotas() {
      if (
        this.accountInfo &&
        this.accountInfo.dailyBookingQuotas &&
        this.accountInfo.dailyBookingQuotas.length
      ) {
        return {
          cckpl: this.convertToViewModel(
            this.accountInfo.dailyBookingQuotas.find((x) => x.code === "CCKPL")
          ),
          studyArea: this.convertToViewModel(
            this.accountInfo.dailyBookingQuotas.find(
              (x) => x.code === "StudyArea"
            )
          ),
        };
      }

      return null;
    },
  },
  methods: {
    convertToViewModel(dailyBookingQuota) {
      if (!dailyBookingQuota) {
        return null;
      }

      const text =
        this.convertMinutesToHoursMinutes(
          dailyBookingQuota.remainingQuotaInMinutes
        ) +
        " / " +
        this.convertMinutesToHoursMinutes(dailyBookingQuota.quotaInMinutes);

      const percentage =
        (dailyBookingQuota.remainingQuotaInMinutes /
          dailyBookingQuota.quotaInMinutes) *
        100;

      return {
        text,
        percentage,
        ...dailyBookingQuota,
      };
    },
    convertMinutesToHoursMinutes(minutes) {
      return formatters.convertMinutesToHoursMinutes(minutes);
    },
    setContentHeight() {
      if (this.$refs.accountScrollable) {
        const heights = this.heights();
        const contentHeight =
          heights.screen - heights.toolbar - heights.bottombar - 29 - 33 - heights.noticeBarHeight; //29px = "Daily Booking Quotas" header bar, 33px = "Number of bookings left in this month:"

        this.contentHeight = contentHeight;

        this.$refs.accountScrollable.style.height = contentHeight + "px";
      }
    },
    confirmLogout() {
      const yesCallback = async () => {
        this.logout();
      };

      this.updateSystemDialog({
        title: window.$msg.confirmLogout,
        // message: window.$msg.confirmLogout,
        actions: {
          actionType: "YesOrNo",
          yes: {
            callback: yesCallback,
          },
        },
      });
    },
  },
  activated() {
    this.$nextTick(() => this.setContentHeight());
  },
};
</script>
